export const TONE = {
    burgundy: { bg: 'var(--light-poppy)', ink: 'var(--primary)', accent: 'var(--destructive)' },
    emerald: { bg: 'var(--light-green)', ink: 'var(--palette-emerald)', accent: 'var(--success)' },
    navy: { bg: 'var(--light-lilac)', ink: 'var(--palette-navy)', accent: 'var(--palette-navy)' },
    yellow: { bg: 'var(--light-yellow)', ink: '#6b4f00', accent: '#c98a00' },
    orange: { bg: 'var(--light-orange)', ink: 'var(--primary)', accent: 'var(--warning)' },
    neutral: { bg: 'var(--card)', ink: 'var(--foreground)', accent: 'var(--muted-foreground)' },
    muted: { bg: 'var(--surface-neutral)', ink: 'var(--foreground)', accent: 'var(--muted-foreground)' },
    ink: { bg: 'var(--foreground)', ink: 'var(--background)', accent: 'var(--warning)' },
    burgundyDark: { bg: 'var(--primary)', ink: 'var(--background)', accent: 'var(--warning)' },
};
/**
 * Tint a tone's accent toward transparent. Uses `color-mix` so the source
 * color can be any CSS color (hex, named, oklch, var() resolving to any of
 * those) — string-concatenating hex alpha bytes only worked for hex sources
 * and silently invalidated whole declarations when the source was oklch.
 *
 * `percent` is how much of the accent shows through (0–100). Below ~25% the
 * tint is barely perceptible; above ~70% it stops reading as "soft".
 */
export function tintAccent(tone, percent) {
    return `color-mix(in oklab, ${TONE[tone].accent} ${percent}%, transparent)`;
}
/**
 * The canonical "no-image media surface" gradient for a tone. Used as the
 * fallback under image headers (so 404'd images degrade to it) and as the
 * standalone background when no image is supplied.
 */
export function tonalGradient(tone) {
    return `linear-gradient(135deg, ${TONE[tone].bg} 0%, ${tintAccent(tone, 40)} 100%)`;
}
//# sourceMappingURL=tone.js.map